import { combineReducers } from '@reduxjs/toolkit';

import user from './user/model';
import locationNew from './locationNew/model';
import reviewInvite from './reviewInvite/model';
import breadcrumbs, * as fromBreadcrumbs from './breadcrumbs/model';
import rogbot, * as fromRogbot from './rogbot/model';
import googlePlaces from './googlePlaces/model';
import webchat from './webchat/model';
import permissions, * as fromPermissions from './permissions/model';

export default function createRootReducer() {
  return combineReducers({
    user,
    locationNew,
    reviewInvite,
    breadcrumbs,
    rogbot,
    googlePlaces,
    webchat,
    permissions,
  });
}

// Breadcrumbs
export const getBreadcrumbs = state =>
  fromBreadcrumbs.getBreadcrumbs(state.breadcrumbs);

// Rogbot
export const getFilteredUsers = state =>
  fromRogbot.getFilteredUsers(state.rogbot);
export const getSelectedRoleFilter = state =>
  fromRogbot.getSelectedRoleFilter(state.rogbot);
export const getSelectedStatusFilter = state =>
  fromRogbot.getSelectedStatusFilter(state.rogbot);
export const getRogbotPage = state => fromRogbot.getRogbotPage(state.rogbot);
export const getLiveUsers = state => fromRogbot.getLiveUsers(state.rogbot);

// Permissions
export const getCanViewFlock = state =>
  fromPermissions.getCanViewFlock(state.permissions);
export const getCanViewPartner = state =>
  fromPermissions.getCanViewPartner(state.permissions);
export const getCanAccessRogbot = state =>
  fromPermissions.getCanAccessRogbot(state.permissions);
export const getCanViewAllFlockTabs = state =>
  fromPermissions.getCanViewAllFlockTabs(state.permissions);
export const getCanGraduateLocation = state =>
  fromPermissions.getCanGraduateLocation(state.permissions);
export const getCanAssignUserToOrg = state =>
  fromPermissions.getCanAssignUserToOrg(state.permissions);
export const getCanViewProfileDetails = state =>
  fromPermissions.getCanViewProfileDetails(state.permissions);
export const checkUserRole = state =>
  fromPermissions.checkUserRole(state.permissions);
export const getCanUseTools = state =>
  fromPermissions.getCanUseTools(state.permissions);
